// Legal-form words that do not make a person's name different from a company
// name ("Med Mera Bygg AB" vs "Med Mera Bygg").
const LEGAL_FORMS = new Set(['ab', 'aktiebolag', 'hb', 'handelsbolag', 'kb', 'kommanditbolag', 'ef', 'enskild', 'firma']);

const normalise = (value: string): string =>
  value
    .toLocaleLowerCase('sv-SE')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(word => word && !LEGAL_FORMS.has(word))
    .join(' ');

/**
 * Whether a person's name looks like the company's name – the common mistake of
 * typing the company into the personal "Fullständigt namn" field, which then
 * shows up everywhere ("inbjuden av Med Mera Bygg från Med Mera Bygg").
 * Case, punctuation and legal forms such as "AB" are ignored.
 */
export function nameMatchesCompany(personName: string | null | undefined, companyName: string | null | undefined): boolean {
  const person = normalise(personName ?? '');
  const company = normalise(companyName ?? '');
  return person.length > 0 && person === company;
}
